module.exports = __webpack_public_path__ + "img/cement_mpc_id@2x.ec801375.png";